import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getCurrentSubdomain } from '../../commons/domain';

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
        clientname: PropTypes.string,
    };

    render() {
        const currentRoute = this.props.location.pathname;
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        const { clientname } = this.props;
        const isGW = 
            getCurrentSubdomain().indexOf('gw') !== -1 ||
            (isLoggedIn && clientname === 'Gebrüder Weiss') ||
            localStorage.getItem('theme') === 'gw-theme';
        if (currentRoute.indexOf('admin') > -1 || currentRoute.indexOf('customerdashboard') > -1 || currentRoute.indexOf('/status/') > -1) 
            return null;
        else return (
            <footer className="bg-dark text-center px-3 text-white fixed-bottom">
                <span>
                    {isGW ?
                        'Powered By Deliver-Me Pty LTD. All rights reserved.'
                        :
                        `© ${(new Date()).getFullYear()} Limited. All rights reserved. "Deliver-Me" and "Beautiful business" are trademarks of Deliver-Me Limited.`
                    }
                </span>
            </footer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        isLoggedIn: state.auth.isLoggedIn
    };
};

export default withRouter(connect(mapStateToProps, {})(Footer));


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js